module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_normal_green-4e76ee55401eaef87cda6acf1cfea17e.svg";